import { Checkbox, ListItemText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CompanyRevenueSelectorItemProps {
	fieldName: string;
	value: number[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	companyRevenues: { id: number; value: string }[];
	error?: string;
}

export default function CompanyRevenueSelectorItem({
	fieldName,
	value = [],
	setValue,
	companyRevenues,
	error,
}: CompanyRevenueSelectorItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);

	const handleChange = (event: SelectChangeEvent<number[]>) => {
		const selected = event.target.value as number[];

		setValue(fieldName, selected, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	const handleSelectAll = (selectAll: boolean) => {
		setValue(
			fieldName,
			selectAll ? companyRevenues.map((companyRevenue) => companyRevenue.id) : [],
			{
				shouldValidate: true,
				shouldDirty: true,
			}
		);
	};

	return (
		<Select
			displayEmpty
			fullWidth
			multiple
			error={!!error}
			renderValue={(selected: unknown) =>
				Array.isArray(selected) && selected.length > 0
					? selected
							.map((id) => companyRevenues.find((i) => i.id === id)?.value)
							.filter(Boolean)
							.join(", ")
					: ts("select-company-revenue")
			}
			value={value}
			onChange={handleChange}
		>
			<MenuItem key="-1" value="-1">
				<Checkbox
					checked={value.length === companyRevenues.length}
					sx={{ padding: "4px" }}
					onChange={() => handleSelectAll(value.length !== companyRevenues.length)}
				/>
				<ListItemText primary={ts("select-all")} sx={{ "& span": { m: 0 } }} />
			</MenuItem>
			{companyRevenues.map((companyRevenue) => (
				<MenuItem
					key={companyRevenue.id}
					sx={{ width: "100%", alignItems: "center", m: 0 }}
					value={companyRevenue.id}
				>
					<Checkbox checked={value.includes(companyRevenue.id)} sx={{ padding: "4px" }} />
					<ListItemText primary={companyRevenue.value} sx={{ "& span": { m: 0 } }} />
				</MenuItem>
			))}
		</Select>
	);
}
